import { getCookie } from "utils/cookie";
import { loadBrandParam } from "./common";
import config from "../config.json";

export const localeRegExp = /\/([a-z]{2}((_|-)[A-z]{2})?)(\/|$)/;

export const getDefaultLocale = (brand) => {
	return (config?.brands?.[brand]?.defaultLocale || config.defaultLocale)
		.toLowerCase()
		.replace("_", "-");
};

export const getDefaultLocaleCookie = (brand) => {
	return (
		config?.brands?.[brand]?.defaultLocaleCookie || config.defaultLocaleCookie
	);
};

export const getDefaultLocaleCookieProperty = (brand) => {
	return (
		config?.brands?.[brand]?.defaultLocaleCookieProperty ||
		config.defaultLocaleCookieProperty
	);
};

export const getGDPRLocale = (brand) => {
	const gdprHostnames = config?.brands?.[brand]?.gdprHostnames;
	if (!gdprHostnames) return null;
	let locale;

	for (const hostname in gdprHostnames) {
		if (
			window.location.hostname.includes(hostname) &&
			gdprHostnames[hostname]
		) {
			locale = gdprHostnames[hostname];
			break;
		}
	}
	return locale;
};

export const loadLocaleParam = () => {
	const brand = loadBrandParam();
	let locale = getDefaultLocale(brand);
	let parsedLocale;
	let cookie = null;
	let localeCookieName = getDefaultLocaleCookie(brand);

	if (!config.brands?.[brand]?.preventReadingLocaleFromCookie) {
		cookie =
			getCookie(`${localeCookieName}_aka`) || getCookie(localeCookieName);
	}

	if (cookie) {
		try {
			const cookieJarObj = JSON.parse(decodeURIComponent(cookie));
			const cookieProperty = getDefaultLocaleCookieProperty(brand);
			parsedLocale = cookieJarObj[cookieProperty];
		} catch (error) {
			console.info(`unable to parse the ${localeCookieName}`);
		}
	} else {
		parsedLocale = window.location.pathname
			.match(localeRegExp)?.[0]
			.replace(/\//g, "");
		if (!parsedLocale) {
			parsedLocale = getGDPRLocale(brand);
		}
	}

	if (parsedLocale) {
		const [language, region] = parsedLocale
			.toLowerCase()
			.replace("_", "-")
			.split("-");
		locale = `${language}${region ? "-" + region : ""}`;
	}

	return locale;
};
